export enum PAGES {
    login = 'login',
}
